/* Extracted from snippets/drawer-orchestrator.liquid - pure JS,
   no Liquid interpolation. External + defer to cut HTML payload
   and let the browser cache across pages. */
  (function() {
    /* Each drawer has a click trigger and an "is open" predicate / close
       function. When the user clicks any trigger, close every OTHER
       drawer first - but DO NOT close the one being opened. The handler
       runs in the capture phase so we win the race against the
       component's own click listener that opens the new drawer. */
    var DRAWERS = [
      {
        id: 'whatsapp',
        trigger: '#wa-btn',
        isOpen: function() { return !!document.querySelector('#wa-panel.is-open'); },
        close: function() { if (window.closeWhatsAppPanel) window.closeWhatsAppPanel(false); },
      },
      {
        id: 'cart',
        trigger: '[data-action="cart"], .header__icon--cart',
        isOpen: function() { return !!document.querySelector('cart-drawer.active'); },
        close:  function() {
          var el = document.querySelector('cart-drawer');
          if (!el) return;
          /* Cart-drawer is a custom element with a `close()` method
             (assets/cart-drawer.js). Use that - it does the focus restore,
             scroll unlock, and ARIA reset internally. Fall back to the
             close pill onclick path if the method is missing. */
          if (typeof el.close === 'function') { el.close(); return; }
          var closePill = document.getElementById('cart-drawer-close-pill-flow');
          if (closePill) closePill.click();
          else el.classList.remove('active');
        },
      },
      {
        id: 'mm',
        trigger: '[data-mm-open], [data-action="menu"]',
        isOpen: function() { return document.documentElement.classList.contains('mm-open'); },
        close:  function() {
          var btn = document.querySelector('[data-mm-close]');
          if (btn) btn.click();
          else document.documentElement.classList.remove('mm-open');
        },
      },
      {
        id: 'search',
        trigger: '.search__input, [data-search-trigger]',
        /* Two search systems can be active depending on viewport:
           - mobile: <div id="SearchSheet" class="ss is-open">
             (snippets/search-bottom-sheet.liquid)
           - desktop: <predictive-search> + body.psearch-open
             (assets/predictive-search.js)
           Treat either as "open" so close-others / WA-hide / scroll-lock
           orchestration covers both. */
        isOpen: function() {
          return document.body.classList.contains('psearch-open') ||
                 !!document.querySelector('#SearchSheet.is-open');
        },
        close:  function() {
          /* Mobile sheet has its own close pathway via [data-ss-close]. */
          var sheet = document.querySelector('#SearchSheet.is-open');
          if (sheet) {
            var ssClose = sheet.querySelector('[data-ss-close]');
            if (ssClose) ssClose.click();
            else sheet.classList.remove('is-open');
          }
          /* Desktop predictive search closes via body class removal +
             input blur (mirrors predictive-search.js close()). */
          document.body.classList.remove('psearch-open');
          document.documentElement.classList.remove('psearch-open');
          var input = document.querySelector('.search__input');
          if (input) input.blur();
        },
      },
      {
        id: 'bnpl',
        trigger: '.bnpl-trigger__summary, [data-bnpl-trigger]',
        isOpen: function() { return !!document.querySelector('.bnpl-modal.is-open'); },
        close:  function() { if (typeof window.closeBnplModal === 'function') window.closeBnplModal(); },
      },
      {
        id: 'delivery',
        trigger: '.delivery-estimator__summary, [data-delivery-trigger]',
        isOpen: function() { return !!document.querySelector('.delivery-modal.is-open'); },
        close:  function() { if (typeof window.closeDeliveryModal === 'function') window.closeDeliveryModal(); },
      },
      {
        id: 'account',
        /* Account drawer opens via the header account icon, mobile bottom-
           nav account button, and any anchor with [data-account-drawer-trigger].
           See assets/account-drawer.js for the open/close API. */
        trigger: '[data-account-drawer-trigger], [data-action="account"], .header__icon--account',
        isOpen: function() { return document.body.classList.contains('account-drawer-open'); },
        close:  function() {
          if (typeof window.closeAccountDrawer === 'function') { window.closeAccountDrawer(); return; }
          /* Fallback if the controller hasn't loaded yet. */
          document.body.classList.remove('account-drawer-open');
          document.documentElement.classList.remove('account-drawer-open');
        },
      },
      {
        id: 'trust',
        /* Apple Warranty / Service / Return modals on PDP, all share
           .trust-modal class. Triggered by the trust-badge buttons. */
        trigger: '[onclick*="openTrustModal"], [data-trust-modal-trigger], [data-modal-trigger]:not([data-modal-trigger="delivery-modal"])',
        isOpen: function() { return !!document.querySelector('.trust-modal.is-open'); },
        close:  function() {
          /* trust-badges-modals.liquid exposes window.closeTrustModal(id)
             and iterates open modals on backdrop / Escape. */
          var open = document.querySelector('.trust-modal.is-open');
          if (open && typeof window.closeTrustModal === 'function') {
            window.closeTrustModal(open.id);
            return;
          }
          if (open) open.classList.remove('is-open');
        },
      },
      {
        id: 'sim',
        /* iPhone PDP SIM helper modal - explains Middle East vs Intl. */
        trigger: '.sim-helper-trigger, [data-sim-modal-trigger]',
        isOpen: function() { return !!document.querySelector('.sim-modal.is-open'); },
        close:  function() { if (typeof window.closeSimModal === 'function') window.closeSimModal(); },
      },
      {
        id: 'config',
        /* PDP "More options" uses the same overlay contract as the cart:
           opening it closes any other drawer, while its own close control
           remains responsible for exit motion and focus restoration. */
        trigger: '[data-cad-config-open]',
        isOpen: function() { return !!document.querySelector('dialog.cad-config-dialog[open]'); },
        close:  function() {
          var dialog = document.querySelector('dialog.cad-config-dialog[open]');
          if (!dialog) return;
          var closeButton = dialog.querySelector('[data-cad-config-close]');
          if (closeButton) { closeButton.click(); return; }
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
        },
      },
      {
        id: 'filter-sheet',
        /* Collection page filter / sort bottom-sheet. Managed by
           BottomSheetManager in assets/facets.js. */
        trigger: '[data-open-sheet]',
        isOpen: function() { return !!document.querySelector('.bottom-sheet.active'); },
        close:  function() {
          /* Click the sheet's own close-on-apply button if visible, else
             remove the active class directly. */
          var sheet = document.querySelector('.bottom-sheet.active');
          if (!sheet) return;
          var closeBtn = sheet.querySelector('[data-close-sheet]');
          if (closeBtn) { closeBtn.click(); return; }
          sheet.classList.remove('active');
          var overlay = document.querySelector('.bottom-sheet-overlay.active');
          if (overlay) overlay.classList.remove('active');
        },
      },
    ];

    document.addEventListener('click', function(e) {
      var openingId = null;
      for (var i = 0; i < DRAWERS.length; i++) {
        if (e.target.closest(DRAWERS[i].trigger)) {
          openingId = DRAWERS[i].id;
          break;
        }
      }
      if (!openingId) return;
      /* Close every other drawer that's currently open. */
      DRAWERS.forEach(function(d) {
        if (d.id !== openingId && d.isOpen()) {
          try { d.close(); } catch (err) { /* never block the click */ }
        }
      });
    }, true /* capture: run before component-level openers */);

    /* ─── Background scroll lock ────────────────────────────────────────
       Same pattern as assets/mobile-menu.js:40-58 - document-level
       touchmove + wheel preventDefault, but allow events inside any
       open overlay surface to bubble up. AVOIDS body { overflow: hidden }
       which makes iOS Safari reset the scroll offset and visibly jump
       the page (saw a 368px push-up of the PDP product image when the
       BNPL bottom-sheet opened at scrollY=600). The body keeps its
       `clip visible` composite (mobile horizontal lock from
       theme.liquid:489) throughout - only background gestures are
       blocked. */
    /* IMPORTANT - target the INNER scrollable panel, not the outer
       container. PDP modals (.bnpl-modal, .delivery-modal, .trust-modal,
       .sim-modal) are structured as:

         <div class="trust-modal is-open">      ← outer (fixed inset:0)
           <div class="trust-modal__backdrop">  ← child, full-viewport tint
           <div class="trust-modal__content">   ← child, scrollable panel

       If we matched the OUTER container, every touch on the backdrop
       would also match (since it's a descendant). Result: lockHandler
       would skip preventDefault on backdrop touches → body scrolls
       behind the modal. Bug observed on mobile sim-helper.

       By matching the inner __content panel only, backdrop touches fall
       through to preventDefault (block body scroll), while content
       touches are allowed (panel handles its own scroll natively).

       Cart drawer follows the same rule: only `.drawer__inner` is a
       scrollable surface. Its overlay and fixed outer shell must stay in
       the blocked path, otherwise wheel/touch events over them can scroll
       the document behind the drawer. */
    /* Most specific / nested surfaces first. The first visible open panel is
       the only region that may consume vertical scroll. Backdrops and outer
       fixed shells are deliberately absent. */
    var OPEN_SCROLL_ROOT_SELECTORS = [
      '#wa-panel.is-open [data-wa-view].is-open',
      '#wa-panel.is-open',
      '.mm-policy-sheet.is-open .mm-policy-sheet__content',
      '.mm-contact-popup.is-open .mm-contact-popup__content',
      'cart-drawer.active .drawer__inner',
      '#SearchSheet.is-open .ss__panel',
      'body.psearch-open .search-modal__content',
      '.bnpl-modal.is-open .bnpl-modal__content',
      '.delivery-modal.is-open .delivery-modal__content',
      '.trust-modal.is-open .trust-modal__content',
      '.sim-modal.is-open .sim-modal__content',
      '.bottom-sheet.active',
      'body.account-drawer-open .account-drawer__panel',
      'dialog#AccountDrawerLoadError[open]',
      'cad-overlay.open .cad-overlay__container',
      'cad-overlay.cad-active .cad-overlay__container',
      'dialog.cad-config-dialog[open] .cad-config-dialog__body',
      'quick-add-modal[open] .quick-add-modal__content',
      'modal-dialog[open] .product-popup-modal__content',
      'product-modal[open] [role="document"]',
      '.pswp.pswp--open .pswp__scroll-wrap',
      'html.mm-open .mm-drawer'
    ];

    function findOpenScrollRoot() {
      for (var i = 0; i < OPEN_SCROLL_ROOT_SELECTORS.length; i++) {
        var root = document.querySelector(OPEN_SCROLL_ROOT_SELECTORS[i]);
        if (root) return root;
      }
      return null;
    }

    var lockId = null;
    function applyLock() {
      if (lockId !== null || !window.themeSheetScrollLock) return;
      // Resolve on every event: Section Rendering and app overlays can replace
      // their panel node without closing the surface.
      lockId = window.themeSheetScrollLock.lock(findOpenScrollRoot);
    }
    function releaseLock() {
      if (lockId === null || !window.themeSheetScrollLock) return;
      window.themeSheetScrollLock.unlock(lockId);
      lockId = null;
    }
    function anyOverlayOpen() {
      /* Include closing states. Floating page chrome must stay hidden until
         the overlay has actually finished leaving, otherwise it flashes back
         underneath the closing drawer. */
      return DRAWERS.some(function(d) { return d.isOpen(); }) ||
             document.documentElement.classList.contains('mm-closing') ||
             document.body.classList.contains('account-drawer-closing') ||
             document.body.classList.contains('cad-provider-modal-open') ||
             document.body.classList.contains('cad-drawer-open') ||
             document.body.classList.contains('bottom-sheet-open') ||
             !!document.querySelector(
               'cart-drawer.is-closing, #SearchSheet.is-closing, ' +
               '.mm-contact-popup.is-open, .mm-policy-sheet.is-open, ' +
               'cad-overlay.open, cad-overlay.cad-active, cad-overlay.cad-closing, ' +
               'dialog.cad-config-dialog[open], dialog#AccountDrawerLoadError[open], ' +
               'quick-add-modal[open], modal-dialog[open], product-modal[open], ' +
               '.pswp.pswp--open, .wa-panel.is-open'
             );
    }

    function syncOverlayChrome() {
      /* One DOM state owns the motion of every fixed page-level control.
         Component scripts only own their overlay; they no longer animate
         Rashid, the sticky purchase bar, or the bottom navigation directly. */
      document.documentElement.classList.toggle('theme-overlay-active', anyOverlayOpen());
    }

    /* Watch state changes and mounted/unmounted surfaces. Section Rendering
       and provider dialogs can remove an open node without changing its class;
       ignoring childList leaves chrome hidden and the scroll lock held.
       Keep one observer and the narrow class/open attribute filter. */
    var overlayShellSelector = 'cart-drawer, #wa-panel, #SearchSheet, .bnpl-modal, .delivery-modal, .trust-modal, .sim-modal, .bottom-sheet, .mm-contact-popup, .mm-policy-sheet, cad-overlay, dialog, quick-add-modal, modal-dialog, product-modal, .pswp, .wa-panel';
    function touchesOverlayState(records) {
      for (var i = 0; i < records.length; i++) {
        var record = records[i];
        if (record.type === 'attributes') {
          if (record.target === document.documentElement || record.target === document.body || record.target.matches(overlayShellSelector)) return true;
        } else if (record.type === 'childList') {
          // Reconcile content and removal while open.
          if (document.documentElement.classList.contains('theme-overlay-active') || lockId !== null || currentTrap) return true;
          var nodes = Array.prototype.slice.call(record.addedNodes).concat(Array.prototype.slice.call(record.removedNodes));
          for (var j = 0; j < nodes.length; j++) {
            var node = nodes[j];
            if (node.nodeType === 1 && (node.matches(overlayShellSelector) || node.querySelector(overlayShellSelector))) return true;
          }
        }
      }
      return false;
    }

    var lockTimer = 0;
    var lockObserver = new MutationObserver(function(records) {
      if (!touchesOverlayState(records)) return;
      /* MutationObserver callbacks run before paint. Flip the visual state
         synchronously so every fixed control starts its transition together. */
      syncOverlayChrome();
      if (lockTimer) return;
      lockTimer = setTimeout(function() {
        lockTimer = 0;
        if (anyOverlayOpen()) applyLock();
        else releaseLock();
        syncFocusTrap();
      }, 0);
    });
    lockObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'open'] });
    lockObserver.observe(document.body,            { attributes: true, attributeFilter: ['class', 'open'], childList: true, subtree: true });
    syncOverlayChrome();

    /* ─── Focus trap (Phase 7.6) ────────────────────────────────────────
       When an overlay is open, Tab / Shift+Tab must stay inside it. Without
       this, keyboard users tab out into the page underneath - which is
       hidden by aria-hidden on most overlays, but the focus order itself
       is still reachable, breaking WCAG 2.1.2 (No Keyboard Trap requires
       focus to leave by Esc / close, but ALSO requires focus not to leak
       OUT of a modal dialog while it's open).

       Strategy: each overlay maps to a root-element selector. When we
       detect a transition from "no overlay open" → "overlay X open", we:
         1. Save document.activeElement (so we can restore on close).
         2. Find the first focusable inside the overlay; move focus there.
            (Skip if focus is already inside - the component's own
            open() may have already focused something purposeful.)
         3. Install a keydown listener on the document that, on Tab,
            cycles focus within the overlay's focusable elements.

       On close: remove listener, restore focus to the saved trigger
       element if it's still in the DOM.

       NOT trapping: the desktop predictive-search dropdown (it's a popover
       below the input - the input keeps focus and arrow keys move
       through suggestions; trapping Tab there would block the user
       Tab-ing out to the rest of the page, which is the expected behavior
       of an inline autocomplete). */
    var TRAP_ROOTS = [
      { id: 'cart',         sel: 'cart-drawer.active' },
      { id: 'mm',           sel: 'html.mm-open .mm-drawer' },
      { id: 'mm-contact',   sel: '.mm-contact-popup.is-open' },
      { id: 'mm-policy',    sel: '.mm-policy-sheet.is-open' },
      { id: 'search-sheet', sel: '#SearchSheet.is-open' },
      { id: 'account',      sel: 'body.account-drawer-open .account-drawer__panel' },
      { id: 'bnpl',         sel: '.bnpl-modal.is-open' },
      { id: 'delivery',     sel: '.delivery-modal.is-open' },
      { id: 'trust',        sel: '.trust-modal.is-open' },
      { id: 'sim',          sel: '.sim-modal.is-open' },
      { id: 'filter-sheet', sel: '.bottom-sheet.active' },
      { id: 'config',       sel: 'dialog.cad-config-dialog[open]' },
    ];

    var FOCUSABLE_SEL = [
      'a[href]:not([tabindex="-1"])',
      'area[href]:not([tabindex="-1"])',
      'button:not([disabled]):not([tabindex="-1"])',
      'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
      'select:not([disabled]):not([tabindex="-1"])',
      'textarea:not([disabled]):not([tabindex="-1"])',
      '[tabindex]:not([tabindex="-1"])',
      'summary:not([tabindex="-1"])',
      'details:not([tabindex="-1"])',
      'iframe:not([tabindex="-1"])',
      'audio[controls]:not([tabindex="-1"])',
      'video[controls]:not([tabindex="-1"])',
      'object:not([tabindex="-1"])',
      'embed:not([tabindex="-1"])'
    ].join(',');

    function isVisible(el) {
      if (!el || !el.isConnected) return false;
      /* Cheap check first: getClientRects is empty for display:none. */
      if (!el.getClientRects().length) return false;
      var s = window.getComputedStyle(el);
      if (s.visibility === 'hidden' || s.display === 'none') return false;
      return true;
    }

    function focusableWithin(root) {
      if (!root) return [];
      var nodes = root.querySelectorAll(FOCUSABLE_SEL);
      var out = [];
      for (var i = 0; i < nodes.length; i++) {
        if (isVisible(nodes[i])) out.push(nodes[i]);
      }
      return out;
    }

    function findOpenTrapRoot() {
      for (var i = 0; i < TRAP_ROOTS.length; i++) {
        var el = document.querySelector(TRAP_ROOTS[i].sel);
        if (el && isVisible(el)) return { id: TRAP_ROOTS[i].id, el: el };
      }
      return null;
    }

    var currentTrap = null;       /* { id, el, returnFocus } */
    var trapKeyHandler = null;

    function installTrap(root) {
      var storedTrigger = root.id === 'cart' ? window.__alasilCartReturnFocusElement
        : root.id === 'search-sheet' ? root.el.__searchReturnFocusElement
        : root.id === 'trust' ? root.el._returnFocus : null;
      currentTrap = {
        id: root.id,
        el: root.el,
        returnFocus: storedTrigger && storedTrigger.isConnected
          ? storedTrigger
          : document.activeElement,
      };
      /* If focus isn't already inside the overlay, move it to the first
         focusable element. Components that auto-focus a specific input
         (e.g. search sheet's input, cart-drawer's quantity field) already
         did so in their own open() handlers - we won't override that. */
      if (!root.el.contains(document.activeElement)) {
        var list = focusableWithin(root.el);
        var first = list[0];
        if (first) {
          /* Defer one frame so any open-time focus the component sets
             wins the race (we only want to focus if no one else did). */
          requestAnimationFrame(function() {
            if (currentTrap && !currentTrap.el.contains(document.activeElement)) {
              try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
            }
          });
        }
      }
      trapKeyHandler = function(e) {
        if (e.key !== 'Tab' || !currentTrap) return;
        var list = focusableWithin(currentTrap.el);
        if (!list.length) {
          /* Nothing to focus - keep focus on the overlay root itself. */
          e.preventDefault();
          if (currentTrap.el.tabIndex < 0) currentTrap.el.tabIndex = -1;
          currentTrap.el.focus();
          return;
        }
        var first = list[0];
        var last  = list[list.length - 1];
        var active = document.activeElement;
        if (currentTrap.id === 'cart') {
          e.preventDefault();
          var activeIndex = list.indexOf(active);
          var nextIndex;
          if (activeIndex < 0) nextIndex = e.shiftKey ? list.length - 1 : 0;
          else if (e.shiftKey) nextIndex = activeIndex === 0 ? list.length - 1 : activeIndex - 1;
          else nextIndex = activeIndex === list.length - 1 ? 0 : activeIndex + 1;
          try { list[nextIndex].focus({ preventScroll: true }); }
          catch (focusError) { list[nextIndex].focus(); }
          return;
        }
        /* Focus might be outside the overlay if the component moved it
           somewhere unexpected; cycle back in. */
        if (!currentTrap.el.contains(active)) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
          return;
        }
        if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
      };
      document.addEventListener('keydown', trapKeyHandler, true);
    }

    function restoreReleasedFocus(ret) {
      if (!ret || !ret.isConnected) return;
      var restored = false;
      var focusIfVisible = function() {
        if (restored || !ret.isConnected || !isVisible(ret)) return false;
        restored = true;
        try { ret.focus({ preventScroll: true }); } catch (e) { ret.focus(); }
        if (window.__alasilCartReturnFocusElement === ret) window.__alasilCartReturnFocusElement = null;
        return true;
      };
      if (focusIfVisible()) return;

      // Mobile bottom navigation intentionally stays hidden while the drawer
      // finishes its exit motion. Waiting for that chrome transition prevents
      // focus() on a visibility:hidden trigger from silently falling to body.
      var chrome = ret.closest && ret.closest('.mobile-bottom-menu');
      if (chrome) {
        var onTransitionEnd = function(event) {
          if (event.target !== chrome) return;
          if (focusIfVisible()) chrome.removeEventListener('transitionend', onTransitionEnd);
        };
        chrome.addEventListener('transitionend', onTransitionEnd);
        setTimeout(function() {
          chrome.removeEventListener('transitionend', onTransitionEnd);
          focusIfVisible();
        }, 360);
        return;
      }
      requestAnimationFrame(focusIfVisible);
    }

    function releaseTrap() {
      if (!currentTrap) return;
      if (trapKeyHandler) {
        document.removeEventListener('keydown', trapKeyHandler, true);
        trapKeyHandler = null;
      }
      var ret = currentTrap.returnFocus;
      currentTrap = null;
      restoreReleasedFocus(ret);
    }

    function syncFocusTrap() {
      var open = findOpenTrapRoot();
      if (open) {
        if (!currentTrap) { installTrap(open); return; }
        /* Different overlay opened on top - swap. */
        if (currentTrap.el !== open.el) {
          var savedReturn = currentTrap.returnFocus;
          /* Don't restore to the new overlay's trigger; restore to the
             original trigger of the FIRST overlay opened in this chain. */
          releaseTrap();
          installTrap(open);
          if (currentTrap) currentTrap.returnFocus = savedReturn;
        }
      } else if (currentTrap) {
        releaseTrap();
      }
    }
  })();
